import { weightedRandom } from "./random";

interface Config<T> {
	origin: T;
	destination: T;
	share: number;
}

export class MarkovChain<T> {
	private configs: Config<T>[] = [];

	addConfig(origin: T, destination: T, share: number): void {
		this.configs.push({ origin, destination, share });
	}

	run(origin: T, rng: () => number = Math.random): T {
		const destinations = new Map<T, number>();
		for (const c of this.configs) {
			if (c.origin === origin) {
				destinations.set(c.destination, c.share);
			}
		}
		return weightedRandom(destinations, rng);
	}
}
